<template>
  <v-app>
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </v-app>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const { locale } = useI18n();
const route = useRoute();

watch(
  () => route.query.lang,
  (lang) => {
    if (lang && typeof lang === 'string') {
      locale.value = lang;
    }
  },
  { immediate: true },
);
</script>
